import AppContent from '@Components/app-layout/Content';

import Routes from './Routes';
import Sidebar from './Sidebar';

export default function SettingLayout() {
  return <AppContent>
    <Sidebar />
    <Routes />
  </AppContent>;
}
